<template>
    <div class="row ml-md-3 align-items-center home-hero-details">
        <div class="col-md-5 text-left order-2 order-lg-1">
            <span class="text-normal">
                The Future Belongs to those who prepare
            </span>
            <h1 class="text-left font-bold mb-4 header-text">
                Let's Sell YOU a <span class="text-normal">HOME</span><br />
                not a <span class="text-normal"> HOUSE</span>
            </h1>
            <div class="row mb-3 ml-0">
                <button class="btn-default-style btn-danger-custom mr-4 mb-2"
                @click="setSubscribe">SUBSCRIBE</button>
                <router-link class="btn-default-style blog-btn mb-2" to="/blog">BLOG</router-link>
            </div>
            <span class="text-normal mt-3 d-inline-block pr-4 pr-sm-0">
                Subscribe to our Newsletter to get information on new and existing estate and promotional offers
            </span>
            <div class="row mt-5 mx-0 image-content-container mb-4">
                <div class="image-container mr-md-3 mb-2"
                    :style="{backgroundImage: `url(${backgroundImg1})`}"
                    @click="playVideo('fTfahkmyvfU')">
                    <div class="overlay"></div>
                    <PlayButton />
                </div>
                <div class="image-container"
                    :style="{backgroundImage: `url(${backgroundImg2})`}"
                    @click="playVideo('Oe6mDqGWsdY')">
                    <div class="overlay"></div>
                    <PlayButton />
                </div>
            </div>
        </div>
        <carousel ref="slideCarousel" class="col-md-7 order-1 order-lg-2 row align-items-center" 
            :perPage="1" paginationActiveColor="#6E2169"
            :autoplay="true" :speed="5000" :loop="true" v-if="sliders"
            @pageChange="onPageChange">
            <slide class="col-12 offset-lg-1"
                :class="{
                    'col-md-9 offset-lg-2': index === 4,
                    'col-md-11': index !== 4
                }" 
                v-for="(slider, index) in sliders"
                :key="index">
                <img :src="slider.main_photo" class="img-fluid" :alt="slider.title && slider.title.rendered">
            </slide>
        </carousel>
        <transition
            enter-active-class="animate__animated animate__fast animate__slideInDown animate__bounceInDown"
            leave-active-class="animate__animated animate__fast animate__slideInUp"
            mode="out-in">
            <b-modal id="bv-modal-subscribe" centered hide-footer
                v-model="showSubscribe" @hidden="resetSubscribe">
                <div class="subscribe-indicator"
                    v-if="subscribed || subscribedStatus">
                    <span class="subscribed-message" v-if="subscribed">
                        {{ subscribed }}
                    </span>
                    <LoadingUI v-if="subscribedStatus" />
                </div>
                <div class="subscribe-content" v-if="! subscribed && ! subscribedStatus">
                    <span class="text-normal text-center d-block my-4">
                        Get Amazing Promo Offer & Real Estate News Updates
                    </span>
                    <form action="" class="col-md-10 offset-md-1 modal-form">
                        <div class="form-group mb-3">
                            <input v-model="formData.name" type="text" class="form-control form-control-sm modal-input" placeholder="Full Name">
                        </div>
                        <div class="form-group mb-3">
                            <input v-model="formData.email" type="email" class="form-control form-control-sm modal-input" placeholder="Email">
                        </div>
                        <div class="d-flex justify-content-center">
                            <b-button class="mt-2 btn-default-style center-block modal-btn" 
                            @click="sendSubscription">SUBMIT</b-button>
                        </div>
                    </form>
                    <router-link to="/privacy-policy" class="d-block terms-text text-normal text-center">
                        Terms & Conditions Apply
                    </router-link>
                </div>
            </b-modal>
        </transition>
        <b-modal id="home-modal" @hidden="modalHidden" size="lg" v-model="modalShow" centered>
            <youtube :video-id="videoId" ref="youtube"></youtube>
        </b-modal>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import backgroundImg1 from '../../assets/landing/large_1-678.png'
import backgroundImg2 from '../../assets/landing/real-estate01.png'
import PlayButton from '../common/PlayButton'
import LoadingUI from '../common/LoadingUI'

export default {
    name: 'HeroDetails',
    components: {
        Carousel,
        Slide,
        PlayButton,
        LoadingUI
    },
    computed: {
        subscribed() {
            return this.$store.state.subscribeResponse
        },
        subscribedStatus() {
            return this.$store.state.subscribeStatus
        },
        sliders() {
            return this.$store.state.sliders
        },
        currentIndex: {
            cache: false,
            get() {
                return this.$refs.slideCarousel ? this.$refs.slideCarousel.currentPage : 0;
            }
        }
    },
    data() {
        return {
            backgroundImg1,
            backgroundImg2,
            videoId: '',
            modalShow: false,
            showSubscribe: false,
            formData: {
                name: '',
                email: ''
            },
        }
    },
    methods: {
        sendSubscription() {
            this.$store.dispatch('sendSubscription', this.formData)
        },
        resetSubscribe() {
            this.formData.name = ''
            this.formData.email = ''
            this.$store.dispatch('resetSubscribe')
        },
        setSubscribe() {
            this.showSubscribe = true
        },
        modalHidden() {
           this.$refs.youtube.player.stopVideo()
        },
        playVideo(videoId) {
            this.videoId = videoId
            this.modalShow = true
        },
        onPageChange(currentPage) {
            this.$emit('currentSliderPage', currentPage)
        },
    }
}
</script>

<style>
.header-text {
    font-size: 42px;
}
.image-container {
    cursor: pointer;
    flex: 0 0 47%;
    max-width: 47%;
    height: 140px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 12px;
    position: relative;
}
@media (max-width: 768px) {
    .image-container {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .image-content-container {
        justify-content: center
    }
}
.img-home {
    width: 100%;
}
/* Modal Styles */
.overlay {
    border-radius: 12px;
    background-color: #6E216959;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.modal-input {
  border-radius: 8px;
}
#bv-modal-subscribe .modal-header {
    padding-bottom: 0;
    border-bottom: none;
}
#bv-modal-subscribe button.close {
    position: absolute;
    right: 20px;
    z-index: 100
}
#bv-modal-subscribe .modal-btn, #bv-modal-subscribe .modal-btn:hover {
  background-color: #6E2169!important;
  color: #fff;
  border-radius: 12px !important;
}
.terms-text, .terms-text:hover {
  color: #6E2169;
  font-size: 10px;
  font-style: italic;
  margin-top: 10px;
  position: relative;
  top: 8px;
  text-decoration: none;
}
#bv-modal-subscribe + .modal-backdrop {
  opacity: 0.85
}
/* Carousel Styles */
@media (min-width: 992px) {
    .VueCarousel-pagination {
        position: absolute;
        left: -60px;
        bottom: 25px;
        width: 220px !important;
    }
}
.VueCarousel-dot {
    margin-top: 0px!important;
}
.VueCarousel-dot-container {
    margin-top: 0 !important;
}
.VueCarousel-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* -webkit-animation-name: fadeIn;
    animation-name: fadeIn; */
    transition: transform 2ms ease 0ms !important;
}
.VueCarousel-slide {
    /* -webkit-animation-name: fadeOut;
    animation-name: fadeOut; */
    opacity: 0 !important;
    flex-basis: 0;
}
.VueCarousel-slide-active {
    /* -webkit-animation-name: fadeIn;
    animation-name: fadeIn; */
    transition: all 2s !important;
    opacity: 1 !important;
}
.blog-btn, .blog-btn:hover {
    text-decoration: none;
    color: #000;
    text-align: center;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.animate__fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}
/* Fading exits */
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
.animate__fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}
.subscribe-indicator {
    display: flex;
    min-height: 230px;
    justify-content: center;
    align-items: center;
    padding: 0 20%;
}
.subscribed-message {
    white-space: pre-line;
}
</style>